import React from 'react';
import Img from 'gatsby-image';

export default function CopyBanner({ data, pageContext }) {
  return (
    <>
      {data.image && (
        <div className="section-banner copy">
          <Img className={'hero-image'} fluid={data.image.asset.fluid} loading={"eager"} alt={data.title[pageContext]} fadeIn={false}/>
          <div className="overlay copy"></div>
          <div className="section-banner-text">
            <span className="h5">{data.subtitle[pageContext]}</span>
            <h1>{data.title[pageContext]}</h1>
          </div>
        </div>
      )}
    </>
  );
}
